import UnlinkedTransferAccountsPage from "components/pages/UnlinkedTransferAccountsPage";
import { useBCMSContext } from "@bcm-dev/bcms-vite";
import ManageRecipientAccountsPage from "components/pages/ManageRecipientAccountsPage";

/**
 * @name CaptureCrossAccountMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureCrossAccountMain(props) {
    const context = useBCMSContext();
    const branding = context.state.branding;

    if (branding.options.transferaccts_manage_recipient_abi22 === "true") {
        return <ManageRecipientAccountsPage />
    }

    return <UnlinkedTransferAccountsPage />;
}